// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { BlobEncoding } from "./blob-encoding";
import { BlobKind } from "./blob-kind";

/**
 * Opaque bytes, optionally raw-DEFLATE compressed.
 *
 * `sha256` is over the inflated bytes, never over `data`. A table or
 * overrides blob inflates to a size-prefixed buffer whose identifier is
 * `MCET` or `MCEO`; a text blob inflates to UTF-8.
 */
export class Blob implements flatbuffers.IUnpackableObject<BlobT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Blob {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsBlob(bb: flatbuffers.ByteBuffer, obj?: Blob): Blob {
    return (obj || new Blob()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsBlob(bb: flatbuffers.ByteBuffer, obj?: Blob): Blob {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Blob()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  kind(): BlobKind {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : BlobKind.Unspecified;
  }

  encoding(): BlobEncoding {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : BlobEncoding.Raw;
  }

  inflatedSize(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  sha256(): string;
  sha256(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  sha256(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  data(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  dataLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  dataArray(): Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return new Uint8Array(
      this.bb!.bytes().buffer,
      this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
      this.bb!.__vector_len(this.bb_pos + offset),
    );
  }

  static startBlob(builder: flatbuffers.Builder) {
    builder.startObject(5);
  }

  static addKind(builder: flatbuffers.Builder, kind: BlobKind) {
    builder.addFieldInt8(0, kind, BlobKind.Unspecified);
  }

  static addEncoding(builder: flatbuffers.Builder, encoding: BlobEncoding) {
    builder.addFieldInt8(1, encoding, BlobEncoding.Raw);
  }

  static addInflatedSize(builder: flatbuffers.Builder, inflatedSize: number) {
    builder.addFieldInt32(2, inflatedSize, 0);
  }

  static addSha256(builder: flatbuffers.Builder, sha256Offset: flatbuffers.Offset) {
    builder.addFieldOffset(3, sha256Offset, 0);
  }

  static addData(builder: flatbuffers.Builder, dataOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, dataOffset, 0);
  }

  static createDataVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startDataVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static endBlob(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 10); // sha256
    builder.requiredField(offset, 12); // data
    return offset;
  }

  static createBlob(
    builder: flatbuffers.Builder,
    kind: BlobKind,
    encoding: BlobEncoding,
    inflatedSize: number,
    sha256Offset: flatbuffers.Offset,
    dataOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    Blob.startBlob(builder);
    Blob.addKind(builder, kind);
    Blob.addEncoding(builder, encoding);
    Blob.addInflatedSize(builder, inflatedSize);
    Blob.addSha256(builder, sha256Offset);
    Blob.addData(builder, dataOffset);
    return Blob.endBlob(builder);
  }

  unpack(): BlobT {
    return new BlobT(
      this.kind(),
      this.encoding(),
      this.inflatedSize(),
      this.sha256(),
      this.bb!.createScalarList<number>(this.data.bind(this), this.dataLength()),
    );
  }

  unpackTo(_o: BlobT): void {
    _o.kind = this.kind();
    _o.encoding = this.encoding();
    _o.inflatedSize = this.inflatedSize();
    _o.sha256 = this.sha256();
    _o.data = this.bb!.createScalarList<number>(this.data.bind(this), this.dataLength());
  }

  unpackFields(...fields: string[]): BlobT {
    const t = new BlobT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("kind")) {
      t.kind = this.kind();
    }
    if (fieldSet.has("encoding")) {
      t.encoding = this.encoding();
    }
    if (fieldSet.has("inflated_size")) {
      t.inflatedSize = this.inflatedSize();
    }
    if (fieldSet.has("sha256")) {
      t.sha256 = this.sha256();
    }
    if (fieldSet.has("data")) {
      t.data = this.bb!.createScalarList<number>(this.data.bind(this), this.dataLength());
    }
    return t;
  }
}

export class BlobT implements flatbuffers.IGeneratedObject {
  constructor(
    public kind: BlobKind = BlobKind.Unspecified,
    public encoding: BlobEncoding = BlobEncoding.Raw,
    public inflatedSize: number = 0,
    public sha256: string | Uint8Array | null = null,
    public data: number[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.sha256 === null || this.sha256 === undefined) {
      throw new Error('Required field "sha256" is not set');
    }
    if (this.data === null || this.data === undefined) {
      throw new Error('Required field "data" is not set');
    }
    const sha256 = this.sha256 !== null ? builder.createString(this.sha256!) : 0;
    const data = Blob.createDataVector(builder, this.data);

    return Blob.createBlob(builder, this.kind, this.encoding, this.inflatedSize, sha256, data);
  }

  clone(): BlobT {
    const obj = new BlobT();
    obj.kind = this.kind;
    obj.encoding = this.encoding;
    obj.inflatedSize = this.inflatedSize;
    obj.sha256 = this.sha256;
    obj.data = [...this.data];
    return obj;
  }

  equals(other: BlobT): boolean {
    if (this.kind !== other.kind) return false;
    if (this.encoding !== other.encoding) return false;
    if (this.inflatedSize !== other.inflatedSize) return false;
    if (this.sha256 !== other.sha256) return false;
    if (this.data.length !== other.data.length) return false;
    for (let i = 0; i < this.data.length; i++) {
      if (this.data[i] !== other.data[i]) return false;
    }
    return true;
  }
}

export function verifyBlob(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkScalarField(tablePos, 6, 1);
    verifier.checkScalarField(tablePos, 8, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 10, "sha256");
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    verifier.checkRequiredField(tablePos, 12, "data");
  } finally {
    verifier.popDepth();
  }
}
